export function copyTextToClipboard(textToCopy: string): boolean {
  let success = true;
  let inputElementRef = document.getElementById('copyTextInput') as HTMLInputElement;

  if (!inputElementRef) {
    inputElementRef = document.createElement('input');
    inputElementRef.setAttribute('id', 'copyTextInput');
    document.body.appendChild(inputElementRef);
  }
  inputElementRef.value = textToCopy;
  inputElementRef.select();
  try {
    document.execCommand('copy');
  } catch (err) {
    success = false;
  }
  return success;
}
